import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { LoanRequestsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
};
export const schemaLoanRequestResolver_GetLoanRequestSummaryById = LoanRequestsTableDefinitionZod.nullable();

export type SchemaLoanRequestResolver_GetLoanRequestSummaryById = z.infer<
    typeof schemaLoanRequestResolver_GetLoanRequestSummaryById
>;

export type LoanRequestResolver_GetLoanRequestSummaryById = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetLoanRequestSummaryById
>;
